import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { cn } from './cn';

// Overflow menu. Collapses the row of six export buttons in TransponderView
// (Delen / QR / Kaart / CSV / GPX) into one control.
//
// Radix supplies the parts a hand-rolled menu usually misses: focus moves into
// the menu on open and back to the trigger on close, arrow keys and type-ahead
// work, Escape and outside-click close it, and the trigger gets aria-expanded /
// aria-haspopup automatically.

export function Menu({ trigger, children, align = 'end' }) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>{trigger}</DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align={align}
          sideOffset={6}
          className={cn(
            'z-[200] min-w-[196px] rounded-lg border border-line bg-surface p-1.5 shadow-e3',
            'data-[state=open]:animate-[authFadeIn_140ms_ease-out]',
          )}
        >
          {children}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

export function MenuItem({ icon, children, ...rest }) {
  return (
    <DropdownMenu.Item
      className={cn(
        'flex min-h-11 cursor-pointer select-none items-center gap-2.5 rounded-md px-2.5 py-2',
        'font-body text-[15px] text-ink-2 outline-none',
        'data-[highlighted]:bg-surface-3 data-[highlighted]:text-ink',
        'data-[disabled]:pointer-events-none data-[disabled]:opacity-45',
      )}
      {...rest}
    >
      {icon && <span className="flex w-4 shrink-0 items-center justify-center text-ink-3">{icon}</span>}
      {children}
    </DropdownMenu.Item>
  );
}

export function MenuSeparator() {
  return <DropdownMenu.Separator className="my-1.5 h-px bg-line" />;
}

export function MenuLabel({ children }) {
  return (
    <DropdownMenu.Label className="px-2.5 pb-1 pt-2 font-condensed text-[13px] font-bold uppercase tracking-[0.08em] text-ink-3">
      {children}
    </DropdownMenu.Label>
  );
}
